import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import PubSub from 'pubsub-js';
import Constants from '../../Constants';
import EirButton from '../eir-button/EirButton'

class EirModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
  }
  componentDidMount() {
    this.eirModalToggledToken = PubSub.subscribe(Constants.eventKeys.eirModalToggled, this.handleToggle);
  }

  componentWillUnmount() {
    if (this.eirModalToggledToken) {
      PubSub.unsubscribe(this.eirModalToggledToken);
    }
  }

  handleToggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };

  render() {
    return (
      <div className="Modal-Outer-Div">
        <Modal
          isOpen={this.props.Modal ? this.props.Modal : this.state.modal}
          toggle={this.props.handleToggle ? this.props.handleToggle : this.handleToggle}
          className={"eir-modal eir-fluid-md-w75 " + this.props.className}
          centered={this.props.centered}
        >
          <ModalHeader toggle={this.props.handleToggle ? this.props.handleToggle : this.handleToggle} className="eir-icon icon-close--primary" />
          <ModalBody>
            <div className="container">
              <div className="col align-self-center">
                {this.props.children}
                {this.props.img && <img src={this.props.img} alt="Close" class="close-icon" />}
                {this.props.OverlayHeading && <span className="text-bold"> {this.props.OverlayHeading} </span>}
                {this.props.OverlayCopy1 && <div className="Overlay"><span className="OverlayCopy1"> {this.props.OverlayCopy1}</span>
                  {this.props.OverlayCopy2 && <span className="OverlayCopy2"> {this.props.OverlayCopy2}</span>}</div>}

                {this.props.cta1 &&
                  <div className="modal-CTAs">
                    <EirButton
                      className={(this.props.cta1text ? ' ' : 'd-none ') + " modal-cta1 "}
                      color="primary"
                      outline={this.props.cta1outline}
                      type={this.props.cta1type}
                      text={this.props.cta1text}
                      title={this.props.cta1title}
                      onClick={this.props.cta1onClick}
                    >
                    </EirButton>
                    {this.props.cta2 &&
                      <EirButton
                        className="modal-cta2"
                        color="primary"
                        outline={this.props.cta2outline}
                        type={this.props.cta2type}
                        text={this.props.cta2text}
                        title={this.props.cta2title}
                        onClick={this.props.cta2onClick}
                      ></EirButton>}
                  </div>
                }

              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default EirModal;